import {$, w} from './constants';

let termActive = 'all';
let firstLoad = true;

function loadPosts(term, paged = 1) {
    $.ajax({
        url: cltvo_js_vars.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'load_more',
            term: term,
            paged: paged
        },
        beforeSend: function() {
            $('#legacy_grid').addClass('loading');
        },
        success: function(response) {
            $('#legacy_grid').html(response.grid_html);
            $('#legacy_pagination').html(response.pagination_html);
            $('#legacy_grid').removeClass('loading');
            if (!firstLoad) {
                console.log('Entre aquí')
                $('html, body').animate({
                    scrollTop: $('#legacy_grid_start').offset().top - 120
                }, 400);
            }
            firstLoad = false;
        },
        error: function(xhr) {
            console.error('Error loading posts:', xhr);
        }
    });
}

$(function () {
    const $blog = $('#start-blog');
    if (!$blog.length) return;

    $('html').css('height', 'auto');
    loadPosts(termActive, 1);

    const ASPECT_DESKTOP = 16 / 9;
    const ASPECT_MOBILE  = 9/16;

    function coverSize(el, iframe, aspect) {
    const w = el.clientWidth;
    const h = el.clientHeight;

    let iw = w;
    let ih = w / aspect;

    if (ih < h) {
        ih = h;
        iw = h * aspect;
    }

    iframe.style.width  = `${iw}px`;
    iframe.style.height = `${ih}px`;
    }

    const wraps = document.querySelectorAll('.blog-legacy__hero-wrap');
    if (!wraps.length) return;

    const observers = new WeakMap();

    function applyCover(el) {
    if (observers.get(el)) return;

    const iframes = {
        desktop: el.querySelector('.iframe-desktop'),
        mobile:  el.querySelector('.iframe-mobile'),
    };

    const ro = new ResizeObserver(() => {
        // IMPORTANT: ajusta los dos, así cuando cambie el breakpoint, ya está listo
        if (iframes.desktop) coverSize(el, iframes.desktop, ASPECT_DESKTOP);
        if (iframes.mobile)  coverSize(el, iframes.mobile,  ASPECT_MOBILE);
    });

    ro.observe(el);
    observers.set(el, ro);

    // primer cálculo inmediato
    requestAnimationFrame(() => {
        if (iframes.desktop) coverSize(el, iframes.desktop, ASPECT_DESKTOP);
        if (iframes.mobile)  coverSize(el, iframes.mobile,  ASPECT_MOBILE);
    });
    }

    wraps.forEach(applyCover);

    let t = null;
    window.addEventListener('resize', () => {
    clearTimeout(t);
    t = setTimeout(() => wraps.forEach(applyCover), 150);
    });
    window.addEventListener('orientationchange', () => {
    clearTimeout(t);
    t = setTimeout(() => wraps.forEach(applyCover), 150);
    });
    //Cambio en el pill de categoría
    $('.filter_category').on('click', function(){
        $('.filter_category').removeClass('active');
        $(this).addClass('active');
        termActive = $(this).data('filter');
        loadPosts(termActive, 1); 
        $('#blog_featured').toggle(termActive === 'all');
    });

    // Botón anterior / siguiente
    $(document).on('click', '.button--prev, .button--next', function(e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        const paged = $(this).data('page');
        if (paged) {
            loadPosts(termActive, paged);
        }
    });

    $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 44
                }, 1000);
            }
        }
    });
});

$(function () {
    const $modal = $('#js-legacy-video-modal');
    if (!$modal.length) return;
    const $iframe = $modal.find('iframe');
    const baseSrc = $iframe.attr('src');
    const BREAKPOINT = 900;
    const isMobile = window.innerWidth <= BREAKPOINT;

    $('.js-open-legacy-video').on('click', function() {
        $modal.attr('aria-hidden', 'false').fadeIn(300).addClass('is-open');
        setTimeout(()=>{
            $iframe.attr('src', baseSrc + '?autoplay=1');
        }, 50);
    });

     $('.js-open-legacy-video-mobile').on('click', function() {
        if (!isMobile) return;
        $modal.attr('aria-hidden', 'false').fadeIn(300).addClass('is-open');
        setTimeout(()=>{
            $iframe.attr('src', baseSrc + '?autoplay=1');
        }, 50);
    });

    $('.js-legacy-video-close').on('click', function() {
        $modal.attr('aria-hidden', 'true').fadeOut(150).removeClass('is-open');
        $iframe.attr('src', baseSrc);
    });
});

$(function () {
  const BREAKPOINT = 900;
  const ASPECT = 16 / 9;

  const wraps = document.querySelectorAll('.single-legacy__hero-videoWrap');
  if (!wraps.length) return;

  // Guardamos observers por elemento
  const observers = new WeakMap();

  function applyCover(el) {
    // evita duplicar observers
    if (observers.get(el)) return;

    const iframe = el.querySelector('iframe');
    if (!iframe) return;

    const ro = new ResizeObserver(() => {
      const w = el.clientWidth;
      const h = el.clientHeight;

      let iw = w;
      let ih = w / ASPECT;

      if (ih < h) {
        ih = h;
        iw = h * ASPECT;
      }

      iframe.style.width = `${iw}px`;
      iframe.style.height = `${ih}px`;
    });

    ro.observe(el);
    observers.set(el, ro);
  }

  function removeCover(el) {
    const ro = observers.get(el);
    if (ro) {
      ro.disconnect();
      observers.delete(el);
    }

    const iframe = el.querySelector('iframe');
    if (iframe) {
      // IMPORTANTÍSIMO: limpiamos lo que metió el JS
      iframe.style.width = '';
      iframe.style.height = '';
    }
  }

  function updateMode() {
    const isMobile = window.innerWidth <= BREAKPOINT;

    wraps.forEach((el) => {
      if (isMobile) {
        removeCover(el);     // mobile = inline, que mande el CSS
      } else {
        applyCover(el);      // desktop = cover con observer
      }
    });
  }

  // init
  updateMode();

  // debounce resize/orientationchange
  let t = null;
  $(window).on('resize orientationchange', function () {
    clearTimeout(t);
    t = setTimeout(updateMode, 150);
  });
});